import { AccountService } from 'src/app/services/account.service';
import { Component, OnInit, ViewChild } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

import { MatIconModule } from '@angular/material/icon';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SnackbarService } from 'src/app/services/snackbar.service';
import { AuthService } from 'src/app/services/auth.service';

import { NgxUiLoaderService } from 'ngx-ui-loader';

import { User } from 'src/app/interfaces/User';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule,
     ReactiveFormsModule,MatButtonModule,MatIconModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  animations: [
    trigger('expandAnimation', [
      transition('void => visible', [
        style({ opacity: 0, height: '0', overflow: 'hidden' }),
        animate('150ms ease-out', style({ opacity: 1, height: '*' })),
      ]),
      transition('visible => void', [
        style({ opacity: 1, height: '*', overflow: 'hidden' }),
        animate('120ms ease-in', style({ opacity: 0, height: '0' })),
      ]),
    ]),
  ],
})
export class HeaderComponent implements OnInit {
  user: any;
  userName: string;
  userImage: string;
  userImagePath = environment.imagesUrl;

  currentUser: User = null;
  isNavMenuOpen = false;
  error = null;
wishListCount=0
  constructor(
    private snackbar: SnackbarService,
    private router: Router,
    private AuthService: AuthService,
    private AccountService: AccountService,
    private loader: NgxUiLoaderService,
  ) {}

  ngOnInit(): void {
    this.getUser(); // Fetch initial user data

    this.AccountService.getSharedUser().subscribe((data) => {
      this.user = data;
      this.userName =
        this.user?.user_name ||
        [this.user?.first_name, this.user?.last_name].filter(Boolean).join(' ') ||
        'مستخدم';
      this.wishListCount = this.user?.wishlist_count || 0; 
      
      if (this.user?.user_img) {
        this.userImage = this.userImagePath + this.user.user_img;
      } else {
        this.userImage = '../../../../assets/images/user-profile.png';
      }
    });
  
    // Subscribe to route changes to close the mobile menu
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.closeMobileMenu();
      }
    });
  }

  getUser() {
    // Start loading
    this.loader.start('10002');

    // Fetch user data from the server
    this.AccountService.getUserData().subscribe(
      (res) => {
        // Stop loading
        this.loader.stop('10002');

        // Update the shared user data
        this.currentUser = <User>res['data']['user'];
        this.wishListCount=this.currentUser.wishlist_count
        this.AccountService.setSharedUser({
          ...this.currentUser,
          wishlist_count: this.wishListCount
        });
      },
      (e) => {
        // Stop loading — guest / invalid session is normal, don't toast
        this.loader.stop('10002');
        this.AccountService.setSharedUser(null);
        this.user = null;
        this.wishListCount = 0;
      }
    );
  }

  logout() {
    // Start loading
    this.loader.start();

    this.AuthService.logout().subscribe(
      (res) => {
        // Stop loading
        this.loader.stop();

        // Clear the shared user data
        this.AccountService.setSharedUser(null);

        // Redirect to the login page
        this.router.navigate(['/auth']);
        window.location.href = '/';
      },
      (e) => {
        // Stop loading
        this.loader.stop();

        // Show the error
        this.error = this.snackbar.showError(e);
      }
    );
  }

  openSignInDialog() {
    this.closeMobileMenu();
    this.router.navigate(['/auth/signin']);
  }

  toggleNavMenu() {
    this.isNavMenuOpen = !this.isNavMenuOpen;
  }
  closeMobileMenu() {
    if (this.isNavMenuOpen) {
      this.isNavMenuOpen = false;
    }
  }
  goToHome() {
    this.router.navigate(['/home']);
  }
}
